import { queryOptions } from "@tanstack/react-query";
import { unwrap } from "@majourneys/api-client";
import type { TransferRouteOption } from "@majourneys/booking";
import type { Lang } from "@majourneys/shared";
import { api } from "../../../lib/api";

/** A transfer route as the hub lists it: the form's option plus what the list needs to link. */
export type TransferRouteDto = TransferRouteOption & { subtitle: string | null; citySlug: string };

export const transferKeys = {
  routes: (city: string, lang: string) => ["transfers", "routes", city, lang] as const,
};

export const transferRoutesQueryOptions = (city: string, lang: Lang) =>
  queryOptions({
    queryKey: transferKeys.routes(city, lang),
    queryFn: async () => {
      const res = unwrap(await api.transfers.routes.get({ query: { city, lang } }));
      return (res?.data ?? []) as TransferRouteDto[];
    },
    staleTime: 60_000,
  });
